// src/v3/account/clock.tsx
import { createSvgIcon } from "@mui/material";
import { jsx, jsxs } from "react/jsx-runtime";
var ClockIcon = createSvgIcon(
  /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: [
    /* @__PURE__ */ jsx("mask", { id: "a", fill: "#fff", children: /* @__PURE__ */ jsx("path", { d: "M2 11.75C2 6.368 6.35825 2 11.7402 2 17.132 2 21.5 6.368 21.5 11.75s-4.368 9.75-9.7598 9.75C6.35825 21.5 2 17.132 2 11.75Z" }) }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11.7402.5C5.52787.5.5 5.54153.5 11.75h3c0-4.55553 3.68863-8.25 8.2402-8.25v-3ZM.5 11.75C.5 17.9585 5.52787 23 11.7402 23v-3C7.18863 20 3.5 16.3055 3.5 11.75h-3ZM11.7402 23C17.9595 23 23 17.9614 23 11.75h-3c0 4.5526-3.6955 8.25-8.2598 8.25v3ZM23 11.75C23 5.5386 17.9595.5 11.7402.5v3C16.3045 3.5 20 7.1974 20 11.75h3Z",
        mask: "url(#a)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11.25 7.375c0-.48325-.3918-.875-.875-.875-.48325 0-.875.39175-.875.875v5.0973c0 .3614.19499.6947.51.8717l4.9629 2.7895c.3668.2061.8306.0922 1.0602-.2604.2524-.3878.1232-.9084-.2812-1.1332l-3.9877-2.2164c-.3174-.1764-.5142-.511-.5142-.8741V7.375Z"
      }
    )
  ] }),
  "ClockIcon"
);

export {
  ClockIcon
};
